module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.process === 'signup') ? _c('header', [_c('div', {
    staticClass: "grid-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/global/logo.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "link link-profile"
  }, [_c('span', {
    staticClass: "image-circle"
  }, [(this.$root.profilereg.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    attrs: {
      "src": this.$root.profilereg.profileimg
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(this.$root.profilereg.firstname + ' ' + this.$root.profilereg.surname))])])])]) : _c('header', [_c('div', {
    staticClass: "grid-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/global/logo.svg")
    }
  }), _vm._v(" "), _c('nav', [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/matches"
    }
  }, [_vm._v("Matches")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/everyone"
    }
  }, [_vm._v("Everyone")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/favourites"
    }
  }, [_vm._v("Favourites")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("Projects")])], 1)])]), _vm._v(" "), (this.$root.profile.admin) ? _c('nav', {
    staticClass: "admin"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/admin/overview"
    }
  }, [_vm._v("Stats")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/admin/site"
    }
  }, [_vm._v("Site Admin")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/admin/reports"
    }
  }, [_vm._v("Reports")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/tests"
    }
  }, [_vm._v("Tests")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "link link-profile",
    on: {
      "click": _vm.toggleFunctions
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(this.$root.profile.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": this.$root.profile.profileimg
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "name",
    attrs: {
      "data-userid": this.$root.user.uid
    }
  }, [_vm._v(_vm._s(this.$root.profile.firstname + ' ' + this.$root.profile.surname))])]), _vm._v(" "), _c('a', {
    staticClass: "link-notification",
    class: {
      notify: _vm.unreadNotifications
    },
    on: {
      "click": _vm.toggleNotifications
    }
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-notification",
    class: {
      notify: _vm.chatNotify
    },
    attrs: {
      "to": "/chats"
    }
  }, [_vm._v("Chats")]), _vm._v(" "), _c('div', {
    staticClass: "grid-container",
    attrs: {
      "id": "notifications"
    }
  }, [_c('div', {
    staticClass: "list-box",
    class: {
      active: _vm.notificationsActive
    }
  }, [_vm._l((this.$root.notifications), function(item) {
    return _c('notification-item', {
      key: item['.key'],
      attrs: {
        "senderid": item.from,
        "message": item.content,
        "when": item.when,
        "link": item.link,
        "unread": item.unread
      }
    })
  }), _vm._v(" "), (_vm.showTip) ? _c('span', {
    staticClass: "tip"
  }, [_vm._v("No notifications")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "grid-container profile-functions",
    attrs: {
      "id": "profile-functions"
    }
  }, [_c('div', {
    staticClass: "list-box profile",
    class: {
      active: _vm.functionsActive
    }
  }, [_c('div', {
    staticClass: "list-box-item"
  }, [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": {
        name: 'User Profile',
        params: {
          slug: this.$root.profile.slug
        }
      }
    }
  }, [_vm._v("View Profile")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list-box-item"
  }, [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/share"
    }
  }, [_vm._v("Share PEI.exCHANGE")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list-box-item"
  }, [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/logout"
    }
  }, [_vm._v("Logout")])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d93bfec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = 705
// module chunks = 1